import React from 'react';

import { Star as MUIStarIcon } from '@mui/icons-material';
import classNames from 'classnames';

import { LegacyIconProps } from './Icon.types';
import { useStyles } from './Icon.styles';

export const StarIcon = ({
  size = 'normal',
  color = 'primary',
}: LegacyIconProps) => {
  const { classes } = useStyles();

  return (
    <MUIStarIcon
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    />
  );
};
